"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5500],{

/***/ 5500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ PlaceCard; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9499);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(917);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1463);
/* harmony import */ var _picture_picture__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2786);
/* harmony import */ var _posts_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3349);
/* harmony import */ var _public_img_location_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1271);
/* harmony import */ var _public_img_views2_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3148);
/* harmony import */ var _lib_consts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9006);
/* harmony import */ var _styled_Link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6196);
/* harmony import */ var _favorite_FavoriteButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7344);
/* harmony import */ var _favorite_FavoriteButtonCardWrapper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(146);
/* harmony import */ var _models_favorite__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(494);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5944);



function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }














var _ref2 =  true ? {
  name: "15currb",
  styles: "display:flex;height:100%"
} : 0;

var _ref3 =  true ? {
  name: "nu06ps",
  styles: "border-radius:4px;position:absolute;top:0;left:0;bottom:0;right:0;overflow:hidden"
} : 0;

var _ref4 =  true ? {
  name: "1szjt9p",
  styles: "display:flex;flex:1;flex-direction:column;justify-content:space-between;padding:14px 14px 24px"
} : 0;

var _ref5 =  true ? {
  name: "megt0k",
  styles: "color:#000;font-family:Golos;font-weight:400;font-size:12px;&>div{margin-bottom:6px;}"
} : 0;

var _ref6 =  true ? {
  name: "157xhr7",
  styles: "width:16px;height:16px"
} : 0;

var _ref7 =  true ? {
  name: "eivff4",
  styles: "display:none"
} : 0;

var _ref8 =  true ? {
  name: "1q5jn22",
  styles: "display:flex;align-items:center;margin-right:18px;height:16px;font-family:Golos;font-size:12px;font-style:normal;font-weight:500;line-height:16px;letter-spacing:0.01em;svg{flex:0 0 auto;margin-right:5px;}"
} : 0;

var _ref9 =  true ? {
  name: "157xhr7",
  styles: "width:16px;height:16px"
} : 0;

function PlaceCard(_ref) {
  var place = _ref.place,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className;
  var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.u)();

  var onFormatEventTitle = function onFormatEventTitle(count) {
    if (count === 1) {
      return 'событие';
    }

    if (count > 1 && count < 5) {
      return 'события';
    }

    return 'событий';
  };

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)("div", {
    // actions__item actions__item_scroll
    itemScope: true,
    itemType: "https://schema.org/Place",
    className: "actions__item ".concat(className) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    ,
    css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_11__/* .css */ .iv)((0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
      marginBottom: '16px',
      paddingLeft: 8,
      paddingRight: 8
    }, _lib_consts__WEBPACK_IMPORTED_MODULE_4__/* .DEVICE_SCREENS_MAX_STRING.md */ .fD.md, {
      minHeight: 400
    }),  true ? "" : 0,  true ? "" : 0),
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)("div", {
      css: _ref2,
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsxs */ .BX)("div", {
        // action-card
        css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_11__/* .css */ .iv)({
          height: '100%',
          borderRadius: '4px',
          backgroundColor: '#fff',
          position: 'relative',
          top: 0,
          width: '100%',
          transition: 'all 0.3s ease',
          display: 'flex',
          flexDirection: 'column',
          '&:hover': {
            transform: 'translateY(-4px)',
            boxShadow: theme.constants.boxShadow
          }
        },  true ? "" : 0,  true ? "" : 0),
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsxs */ .BX)(_styled_Link__WEBPACK_IMPORTED_MODULE_5__/* .Link */ .rU // action-card__image-wrapper
        , {
          itemProp: "url",
          href: ['', 'places', place.slug, ''].join('/') // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          ,
          css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_11__/* .css */ .iv)({
            height: 0,
            width: '100%',
            paddingBottom: '75%',
            position: 'relative',
            display: 'block',
            '&:hover': {
              color: theme.colors.black
            }
          },  true ? "" : 0,  true ? "" : 0),
          children: [place.images && place.images[0] && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)("div", {
            // action-card__image
            css: _ref3,
            children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_picture_picture__WEBPACK_IMPORTED_MODULE_0__/* .Picture */ .t, {
              src: place.images[0],
              alt: place.title,
              is360: true
            })
          }), place.events_count && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsxs */ .BX)("div", {
            // action-card__events-counter
            css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_11__/* .css */ .iv)({
              fontFamily: 'Golos',
              position: 'absolute',
              left: '8px',
              bottom: '8px',
              background: 'rgba(40, 40, 40, 0.7)',
              borderRadius: '4px',
              color: theme.colors.white,
              padding: '8px 16px'
            },  true ? "" : 0,  true ? "" : 0),
            children: [place.events_count, " ", onFormatEventTitle(place.events_count)]
          })]
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_favorite_FavoriteButtonCardWrapper__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
          children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_favorite_FavoriteButton__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            kind: _models_favorite__WEBPACK_IMPORTED_MODULE_8__/* .FavoriteKinds.place */ .f.place,
            id: place.remote_id,
            size: "small",
            variant: "red-outline"
          })
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsxs */ .BX)("div", {
          // action-card__info
          css: _ref4,
          children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsxs */ .BX)("div", {
            // action-card__description
            css: _ref5,
            children: [place.addresses && !!place.addresses.length && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsxs */ .BX)(_posts_styled__WEBPACK_IMPORTED_MODULE_1__/* .DescriptionItem */ .tH, {
              children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_public_img_location_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                fill: theme.colors.red,
                css: _ref6
              }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)("span", {
                itemProp: "address",
                children: place.addresses[0]
              })]
            }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)("span", {
              itemProp: "telephone",
              css: _ref7,
              children: place.phone_number || ''
            })]
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_styled_Link__WEBPACK_IMPORTED_MODULE_5__/* .Link */ .rU // action-card__title
          , {
            href: ['', 'places', place.slug, ''].join('/'),
            css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_11__/* .css */ .iv)({
              fontFamily: 'Montserrat',
              fontSize: '18px',
              fontStyle: 'normal',
              fontWeight: 700,
              lineHeight: '22px',
              letterSpacing: '0em',
              color: theme.colors.black,
              textDecoration: 'none',
              marginBottom: 10,
              display: 'flex',
              alignItems: 'center',
              flex: 1,
              '&:hover': {
                color: theme.colors.black
              }
            },  true ? "" : 0,  true ? "" : 0),
            children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)("span", {
              itemProp: "name",
              children: place.title
            })
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)("div", {
            css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_11__/* .css */ .iv)({
              position: 'absolute',
              bottom: '12px',
              right: '20px',
              left: '20px',
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
              color: theme.colors.grayStrong,
              fontSize: '12px',
              fontWeight: 500
            },  true ? "" : 0,  true ? "" : 0),
            children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsxs */ .BX)("div", {
              css: _ref8,
              children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_public_img_views2_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                fill: theme.colors.grayStrong,
                css: _ref9
              }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)("span", {
                children: place.views
              })]
            })
          })]
        })]
      })
    })
  });
}

/***/ })

}]);